import { FunctionComponent } from "react";
import { ChevronOrientation, IconProps } from "./constants";
import * as Styled from "./styles";

interface ChevronIconProps extends IconProps {
  orientation: ChevronOrientation;
}

const ChevronIcon: FunctionComponent<ChevronIconProps> = ({
  width = 9,
  height = 17,
  color = "#C3CAC9",
  orientation,
  className = "",
}) => {
  return (
    <Styled.ChevronIconWrapper $orientation={orientation} className={className}>
      <svg width={width} height={height} viewBox={`0 0 9 17`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1 15.5L8 8.5L0.999999 1.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Styled.ChevronIconWrapper>
  );
};

export default ChevronIcon;
